import { Typography } from '@mui/material';
import { Box } from '@mui/system';
import { useTitle } from 'shared/hooks';
import { UserInfo } from 'shared/types';
import { Table } from './table';

interface FreightPageProps {
  user: UserInfo;
}
export function FreightPage({ user }: FreightPageProps) {
  useTitle('Freight');
  return (
    <Box sx={{ display: 'flex', flexDirection: 'column' }}>
      <Typography sx={{ alignSelf: 'center', py: 2 }} variant='h4'>
        Freight Management
      </Typography>
      <Table user={user} />
    </Box>
  );
}
